import studentGradeService from "../../apiServices/student/studentGradeService";
import { setStudentGradeDetail } from "../../store/slices/student/studentGradeSlice";



export function getStudentGradeDetail(studentId:string) {
    return async function (dispatch: any, getState: any) {
        let response = await studentGradeService.getGradesDetails(studentId);
        if (response?.success === true) {
            dispatch(setStudentGradeDetail(response.data));
        } else {
            console.log("error");
        }
    };
}